import { useMainStore } from '@/store'; // adjust if needed
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import Dashboard from '../pages/Dashboard.vue';
import { setPageTitle } from '@/composables';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/delivery-box',
    name: 'delivery-box',
    component: () => import('../pages/DeliveryBox.vue'),
  },
  {
    path: '/default-categories',
    name: 'default-categories',
    component: () => import('../pages/DefaultCategories.vue'),
  },
  {
    path: '/resellers-management',
    name: 'resellers-management',
    component: () => import('../pages//ResellersManagement/ResellersManagement.vue'),
  },
  {
    path: '/order-barcode',
    name: 'order-barcode',
    component: () => import('../pages/OrderBarcode.vue'),
  },
  {
    path: '/generate-drawing-sheet',
    name: 'generate-drawing-sheet',
    component: { template: '<div></div>' },
    beforeEnter() {
      window.location.href = '/generate-drawing-sheet/index.html';
    },
  },
  {
    path: '/buying-groups-sales-reps',
    name: 'buying-groups-sales-reps',
    component: () => import('@/pages/BuyingGroupSalesRep.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes,
});

let isUserInitialized = false;

router.beforeEach(async (to, from, next) => {
  const store = useMainStore();
  const queryToken = to.query.access_token as string | undefined;
  setPageTitle();

  if (queryToken) {
    // Save token and remove from URL
    localStorage.setItem('access_token', queryToken);

    // Clone the current query params, remove the token
    const { access_token, ...cleanQuery } = to.query;

    // Redirect to same path without token in query
    return next({
      path: to.path,
      query: cleanQuery,
      replace: true,
    });
  }

  const token = localStorage.getItem('access_token');

  if (token && !isUserInitialized) {
    try {
      await store.getPermissions();
      await store.getNavigation();
      await store.getCurrentUser();

      isUserInitialized = true;

      if (!store.permissions.includes('access-new-dashboard')) {
        await store.logout();
        return;
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      await store.logout();
      return;
    }
  }

  next();
});

export default router;
